import { axios } from "utils";

import { PUBLIC_POPUPS_URL as endpoint } from "consts";

import { FullPopup } from "models";

export const getFullPopup = async (data: { language: string; signal: AbortSignal; type: string }): Promise<FullPopup> =>
  axios.get(`${endpoint}/${data.type}?language=${data.language}`, { signal: data.signal });
